<pdf-viewer  [src]="pdfData"
[autoresize]="true"
[original-size]="false"
[render-text]="false"
style="display: block; max-width: 350px;"
></pdf-viewer>